exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ellipsis-text .space[data-v-0acce701]{width:0;float:right}.ellipsis-text .expand-btn[data-v-0acce701]{float:right;clear:both;cursor:pointer;color:#436bff}.ellipsis-3[data-v-0acce701]{word-break:break-all;overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}\n", ""]);

